import React, { useEffect, useState } from "react";
import Home from "../Home";
import { Progress } from "../dimensions";
import * as image from "../../resources/images";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersDetail, userCoupanOffer } from "../../redux/actions/APIs";
const CouponPopUp = ({ closePopup }) => {
	const dispatch = useDispatch();
	const { response, defaultChildData, loggedInUser, userCoupanResp } = useSelector(
		(state) => state.collections
	);

	const [discountValue, setDisCountValue] = useState("25%");
	const [loader, setLoader] = useState(false);
	const [isSuccess, SetIsSuccess] = useState(false);
	// console.log("loggedInUser @@@ : ",discountValue ,loggedInUser);
	const handdlleDisCount = () => {
		let obj = {
			coupan: discountValue,
			isSelected: true,
		};
		// console.log("handdlleDisCount : ", obj);
		setLoader(true);
		dispatch(userCoupanOffer(loggedInUser?.id, obj));
	};

	useEffect(() => {
		if (userCoupanResp?.success) {
			setLoader(false);
			dispatch(userCoupanOffer());
			dispatch(getAllUsersDetail());
			if (discountValue === "Skip") {
				closePopup();
				return;
			}
			SetIsSuccess(true);
		}
	}, [userCoupanResp]);
	// console.log("discountValue : ", discountValue);
	return (
		<>
			<div className="newinfo_popup newinfo_popupdimension  offer_discountpopup">
				<div
					class="modal d-flex downgradepopup sectionscorecard"
					id="schoolactivity188"
					role="dialog"
				>
					<div class="modal-dialog modal-lg">
						<div class="modal-content">
							<div class="modal-header p-0 border-0">
								<div class="heading p-0 border-0 w-100">
									<h2 class="flex">
										<button
											class="btn btn-primary"
											data-dismiss="modal"
											onClick={() => closePopup()}
										>
											<i class="fa-regular fa-xmark m-0"></i>
										</button>
									</h2>
								</div>
							</div>
							<div class="modal-body p-0">
								{
									!isSuccess ? (
										<div class="flex coupan_boximage">
											<div class="challenge_img w-40 text-center">
												<h3 class="mb-3">
													Commit to your child's success and save!
												</h3>
												<img src={image.gift_offer} alt="Musical" />
											</div>
											<div class="pr-3 offer_text w-60">
												<div className="discount_coupon Active_couponcrd">
													<div class="flexone mb-2 radio_checked">
														<label class="Selcheckbox m-0 ActiveQQst w-100">
															<div className="offer_side">
																<h2>25% discount </h2>
																<p>For one full year on any plan</p>
															</div>
															{console.log(
																"discountValue : ",
																discountValue === "25%",
																discountValue === "50%"
															)}
															<input
																type="radio"
																id={"option1"}
																name={"option1"}
																defaultChecked={discountValue === "25%"}
																onClick={() => setDisCountValue("25%")}
															/>
															<span class="checkmark"></span>
														</label>
													</div>
													<h4>
														Complete one (1) course and do one (1) 30-minute
														feedback call
													</h4>
												</div>

												<div className="discount_coupon">
													<div class="flexone mb-2 radio_checked">
														<label class="Selcheckbox m-0 ActiveQQst w-100">
															<div className="offer_side">
																<h2>50% discount </h2>
																<p>For one full year on any plan</p>
															</div>
															<input
																type="radio"
																id={"option1"}
																name={"option1"}
																defaultChecked={discountValue === "50%"}
																onClick={() => setDisCountValue("50%")}
															/>

															<span class="checkmark"></span>
														</label>
													</div>
													<h4>
														Complete two (2) courses and do two (2) 30-minute
														feedback calls
													</h4>
												</div>

												<div className="discount_coupon  not_interestedblock mt-3 border-0">
													<div class="flexone mt-2 radio_checked">
														<label class="Selcheckbox m-0 ActiveQQst w-100">
															<h4 className="p-0">
																Skip for now – I understand my child may miss out on key life skills.
															</h4>
															<input
																type="radio"
																id={"option1"}
																name={"option1"}
																defaultChecked={discountValue === "Skip"}
																onClick={() => setDisCountValue("Skip")}
															/>
															<span class="checkmark"></span>
														</label>
													</div>
												</div>
											</div>
										</div>
									) : discountValue === "25%" ? (

										<div class="flex coupan_boximage">
											{/*	<div class="challenge_img w-40 text-center">
												 <h3 class="mb-3">
													Commit to your child's success and save!
												</h3> 
												<img src={image.gift_offer} alt="Musical" /> 
											</div>
											*/}
											<div class="pr-3 offer_text w-100 coupaon_msg">
												<div class="p-5 m-3">
													<h2 class="mb-3 thanks_msg">
														<span className="">
															<img src={image.newcheckicon} alt="checkicon" className="mr-2" /> Option 1 Selected
														</span>
														<strong className="mt-1 d-block">	Thank you for committing to your child’s growth!
														</strong>
													</h2>
													<p className="text-center">
														We’ve logged your offer. Once you complete <strong>one course</strong>, we’ll send you an email with instructions to <strong>schedule your 30-minute feedback call</strong>. After the call, you’ll receive your <strong> 25% discount code</strong> for a full year. You’re making a meaningful difference!
													</p>
												</div>
											</div>
										</div>
									) : discountValue === "50%" && (
										<div class="flex coupan_boximage">
											<div class="pr-3 offer_text w-100 coupaon_msg">
												<div class="p-5 m-3">
													<h2 class="mb-3 thanks_msg">
														<span className="">
															<img src={image.newcheckicon} alt="checkicon" className="mr-2" />Option 2 Selected
														</span>
														<strong className="mt-1 d-block">Amazing! You’ve taken a big step toward your child’s success.</strong>
													</h2>
													<p className="text-center">
														Your offer is logged. After you complete <strong>each of the two courses</strong> , we’ll send you an email with instructions to schedule a
														30-minute feedback call. Once both courses and calls are completed, you’ll receive your <strong>50% discount code</strong>  for a full year. You’re helping build a brighter future!
													</p>

												</div>
											</div>
										</div>
									)
								}
								<div className="modal-footer">
									<div className="form-group BDsubmitbutton d-flex m-0">
										<div className="buttonDistribotion">
											<div className="buttonDistribotion justify-content-end">
												{isSuccess && (
													<button
														type="button"
														className="btn-blue btn-login d-block mb-5 cancelbutton"
														onClick={() => closePopup()}
													>
														<i className="fa-solid fa-xmark"></i> Close
													</button>
												)}
												{
													//   loader ? (
													//   <button
													//     className="btn-blue btn-login d-block ml-auto mr-2  w-auto"
													//     disabled
													//   >
													//     <span className="RounAnimation mr-1"></span>{" "}
													//     Please Wait...
													//   </button>
													// ) : (
													!isSuccess &&
													(<>
														<button
															type="button"
															className="btn-blue btn-login d-block mb-5 cancelbutton"
															onClick={() => closePopup()}
														>
															<i className="fa-solid fa-xmark"></i> Cancel
														</button>
														<button
															type="button"
															className="btn-blue btn-login d-block mb-5"
															onClick={() => handdlleDisCount()}
														>
															<i class="fa-regular fa-circle-check"></i>Select Offer</button>
													</>
													)
													// )
												}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default CouponPopUp;
